import { render } from "./3DFile.vue?vue&type=template&id=226c7830"
import script from "./3DFile.vue?vue&type=script&lang=js"
export * from "./3DFile.vue?vue&type=script&lang=js"

import "./3DFile.vue?vue&type=style&index=0&id=226c7830&lang=scss"

import exportComponent from "/home/admin/armada-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__